<template>
    <div class="right_btn">
        <div class="box_1 flex-row justify-between">
            <div class="group_1 flex-col" :style="{ display: displayOne }">
                <img class="image_1" referrerpolicy="no-referrer" :src=consultImg />
                <span class="text_1">【扫码进行咨询】</span>
            </div>
            <div class="box_2 flex-col" :style="{ display: displayTwo }">
                <span class="text_5">官方电话</span>
                <span class="text_6">【181-8864-1716】</span>
            </div>
            <div class="group_2 flex-col">
                <div class="toTop flex-col" @mouseenter="enters('3')" @mouseleave="leaver('3')" @click="toTop">
                    <img class="label_1" referrerpolicy="no-referrer" :src=toTopImg />
                    <span class="text_2">回顶部</span>
                </div>
                <div class="group_4 flex-col" @mouseenter="enters('1')" @mouseleave="leaver('1')">
                    <img class="label_2" referrerpolicy="no-referrer" :src=weixinImg />
                    <span class="text_3">官方微信</span>
                </div>
                <div class="toPhone flex-col" @mouseenter="enters('2')" @mouseleave="leaver('2')">
                    <img class="label_3" referrerpolicy="no-referrer" :src=toPhoneImg />
                    <span class="text_4">电话</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import img1 from "@/assets/img/right/1.png";
import img2 from "@/assets/img/right/2.png";
import img3 from "@/assets/img/right/3.png";
import img4 from "@/assets/img/right/4.png";
import img5 from "@/assets/img/right/5.png";
import img6 from "@/assets/img/right/6.png";
import img7 from "@/assets/img/right/7.png";
export default {
    name: "Right",
    data() {
        return {
            consultImg: img1,
            toTopImg: img2,
            weixinImg: img3,
            toPhoneImg: img4,
            displayOne: "none",
            displayTwo: "none",
        }
    },
    mounted() {

    },
    methods: {
        toTop() {
            let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            if (scrollTop > 0) {
                const timeTop = setInterval(() => {
                    document.documentElement.scrollTop = document.body.scrollTop = scrollTop -= 50; //一次减50往上滑动
                    if (scrollTop <= 0) {
                        clearInterval(timeTop);
                    }
                }, 10); //定时调用函数使其更顺滑
            }
        },
        enters(parms) {
            switch (parms) {
                case "1":
                    this.weixinImg = img5
                    this.displayOne = "flex"
                    break;
                case "2":
                    this.toPhoneImg = img6
                    this.displayTwo = "flex"
                    break;
                case "3":
                    this.toTopImg = img7
            }
        },
        leaver(parms) {
            switch (parms) {
                case "1":
                    this.weixinImg = img3
                    this.displayOne = "none"
                    break;
                case "2":
                    this.toPhoneImg = img4
                    this.displayTwo = "none"
                    break;
                case "3":
                    this.toTopImg = img2
                    break;
            }
        },
    }
}
</script>
<style lang="scss" scoped>
.right_btn {
    position: fixed;
    bottom: 120px;
    right: 5px;
    z-index: 10;
}

.box_1 {
    height: 209px;
    position: relative;
}

.group_1 {
    background-color: rgba(243, 243, 243, 1);
    border-radius: 6px;
    width: 112px;
    height: 137px;
    position: absolute;
    bottom: 0px;
    right: 82px;
    align-items: center;
}

.image_1 {
    width: 90px;
    height: 90px;
    margin: 10px 0 0 0;
}

.text_1 {
    height: 15px;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 12px;
    margin: 12px 0 10px 0;
}

.box_2 {
    background-color: rgba(243, 243, 243, 1);
    border-radius: 6px;
    width: 112px;
    height: 50px;
    position: absolute;
    bottom: 0px;
    right: 82px;
    align-items: center;
}

.text_5 {
    height: 15px;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
    margin: 8px 0 0 0;
}

.text_6 {
    height: 15px;
    overflow-wrap: break-word;
    color: rgba(51, 51, 51, 1);
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: left;
    white-space: nowrap;
    line-height: 12px;
    margin: 4px 0 8px 0;
}

.group_2 {
    background-color: rgba(243, 243, 243, 1);
    border-radius: 6px;
    width: 72px;
    height: 207px;
    justify-content: flex-center;
}

.toTop {
    width: 72px;
    height: 69px;
    align-items: center;
    justify-content: center;
    border-radius: 6px 6px 0 0;
}

.toTop:hover {
    background-color: rgba(255, 127, 55, 1);

    .text_2 {
        color: white;
    }
}

.label_1 {
    width: 22px;
    height: 22px;
}

.text_2 {
    height: 14px;
    overflow-wrap: break-word;
    color: #999999;
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 12px;
    margin: 9px 0 0 0;
}

.group_4 {
    width: 72px;
    height: 69px;
    align-items: center;
    justify-content: center;
}

.group_4:hover {
    background-color: rgba(255, 127, 55, 1);

    .text_3 {
        color: white;
    }
}


.label_2 {
    width: 22px;
    height: 22px;
}

.text_3 {
    height: 14px;
    overflow-wrap: break-word;
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 12px;
    margin: 9px 0 0 0;
    color: #999999;
}

.toPhone {
    width: 72px;
    height: 69px;
    align-items: center;
    justify-content: center;
    border-radius: 0 0 6px 6px;
}

.toPhone:hover {
    background-color: rgba(255, 127, 55, 1);

    .text_4 {
        color: white;
    }
}

.label_3 {
    width: 22px;
    height: 22px;
}

.text_4 {
    height: 14px;
    overflow-wrap: break-word;
    color: #999999;
    font-size: 12px;
    font-family: 思源黑体;
    font-weight: NaN;
    text-align: center;
    white-space: nowrap;
    line-height: 12px;
    margin: 9px 0 0 0;
}
</style>


// WEBPACK FOOTER //
// src/components/Right/index.vue